import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { IUniversalSearchItem } from 'app/shared/components/universal-search/interfaces/universal-search-item.interface';
import { Observable } from 'rxjs';
import { UniversalSearchDialogComponent } from './universal-search-dialog.component';

@Injectable({
    providedIn: 'root',
})
export class UniversalSearchDialogService<TRequest = IUniversalSearchItem[], TResponse = unknown> {
    private dialogRef: MatDialogRef<UniversalSearchDialogComponent>;

    public constructor(private readonly dialog: MatDialog) {
    }

    public open(data?: TRequest): Observable<TResponse> {
        const config: MatDialogConfig<TRequest> = {
            data,
            disableClose: false,
            maxWidth: '100%',
            width: '75rem',
            panelClass: ['ppi-dialog', 'ppi-dialog--transparent', 'ppi-dialog--eye-level-center', 'mobile-fullscreen-dialog'],
        };

        this.dialogRef = this.dialog.open(UniversalSearchDialogComponent, config);
        return this.dialogRef.afterClosed();
    }

    public close(result?: unknown): void {
        if (!this.dialogRef) {
            return;
        }

        this.dialogRef.close(result);
    }
}
